import { c as _c } from "react/compiler-runtime";
import { InfoBar } from "@components/common/info-bar/info-bar";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useTeamsAccess } from "@hooks/access-control/use-teams-access";
import { CreateTeam } from "@pages/members/teams/create-team";
import { TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
import { useAppSelector } from "@store/store-helper";
import { fetchingTeamsFlagsSelector, teamsSelector } from "@store/teams/teams-selector";

/**
 * Shows the main details for the teams
 */
export function TeamsDetails() {
  const $ = _c(9);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const teams = useAppSelector(teamsSelector);
  const {
    status
  } = useAppSelector(fetchingTeamsFlagsSelector);
  const {
    canCreateNewTeam
  } = useTeamsAccess();
  if (status === "pending") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <InfoBar isLoading={true} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== teams.length) {
    t0 = [{
      label: `Total ${TEAMS_DISPLAY_NAME}`,
      content: teams.length
    }];
    $[1] = teams.length;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CreateTeam />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !canCreateNewTeam || isScreenSmOrSmaller;
  let t3;
  if ($[4] !== t2) {
    t3 = {
      content: t1,
      isHidden: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t0 || $[7] !== t3) {
    t4 = <InfoBar items={t0} action={t3} />;
    $[6] = t0;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}